import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgClass = type === 'success' ? 'bg-success' : (type === 'danger' ? 'bg-danger' : 'bg-primary');

  return (
    <motion.div
      initial={{ opacity: 0, y: 50, scale: 0.3 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
      className={`fixed-bottom mb-4 mx-auto p-3 text-white rounded-pill shadow-lg text-center fw-bold ${bgClass}`}
      style={{ width: 'fit-content', minWidth: '280px', zIndex: 10000, left: 0, right: 0, fontFamily: 'var(--font-headline)' }}
    >
      <div className="d-flex align-items-center justify-content-center gap-2">
        {type === 'success' ? '✅' : '⚠️'}
        <span className="arabic-leading">{message}</span>
      </div>
    </motion.div>
  );
};

export default Toast;
